import { render, staticRenderFns } from "./newSingleSource.vue?vue&type=template&id=12f55f8c&scoped=true"
import script from "./newSingleSource.vue?vue&type=script&lang=js"
export * from "./newSingleSource.vue?vue&type=script&lang=js"
import style0 from "./newSingleSource.vue?vue&type=style&index=0&id=12f55f8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f55f8c",
  null
  
)

export default component.exports